import TrainingCourseListPage from '../TrainingCourses/ListPage';
import {useTranslation} from 'react-i18next';
import usePageMeta from '../../services/page-meta';

export default function FinishedCoursesListPage() {
    const {t} = useTranslation();
    usePageMeta({
        title: t('courses.finished.title', t('courses.title')),
        description: t('app.description'),
        keywords: t('app.keywords'),
    });

    return <TrainingCourseListPage isTesting={false} tab="finished" />;
}
